export default "/dist/files/rubrique_presentation.e88c0a80bfbace89790e21754d515291.svg";